var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSubscribe = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "currentColor",
  viewBox: "0 0 280 280"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M77.987 173.392c15.78 0 28.621 12.841 28.621 28.621s-12.841 28.622-28.621 28.622-28.622-12.842-28.622-28.622 12.842-28.621 28.622-28.621m-19.081-66.784c63.13 0 114.486 51.357 114.486 114.486H154.31c0-52.616-42.799-95.405-95.405-95.405zm0-57.243c94.69 0 171.729 77.04 171.729 171.73h-19.081c0-84.167-68.482-152.649-152.648-152.649zm19.08 143.108c-5.256 0-9.54 4.283-9.54 9.54s4.284 9.54 9.54 9.54c5.258 0 9.541-4.283 9.541-9.54s-4.283-9.54-9.54-9.54"
})));
export default SvgSubscribe;